import type { IIndicatorTheme } from '@visactor/vchart';

export const indicator: IIndicatorTheme = {
  title: {
    visible: true
  },
  content: {
    visible: true
  }
};
